"use strict";

exports.__esModule = true;
exports.LayoutEditor = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ElementEditor = require("../ElementEditor");
var _userActionsContext = require("../../UserActions/userActionsContext");
var _class;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * An interface for editing layouts
 */
var LayoutEditor = exports.LayoutEditor = (0, _userActionsContext.withUserActionsContext)(_class = /*#__PURE__*/function (_Component) {
  function LayoutEditor() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleElementChange = function (element) {
      var _this$props = _this.props,
        value = _this$props.value,
        onChange = _this$props.onChange;
      onChange(Object.assign({}, value, {
        element: element
      }));
    };
    return _this;
  }
  _inheritsLoose(LayoutEditor, _Component);
  var _proto = LayoutEditor.prototype;
  _proto.render = function render() {
    var _this$props2 = this.props,
      widgets = _this$props2.widgets,
      value = _this$props2.value,
      userActions = _this$props2.userActions;
    var element = value.element;
    return /*#__PURE__*/_react["default"].createElement(_ElementEditor.ElementEditor, {
      widgets: widgets,
      userActions: userActions,
      onChange: this.handleElementChange,
      rootElement: element
    });
  };
  return LayoutEditor;
}(_react.Component)) || _class;